/** @format */

import axios from "axios";
import { Config } from "config";

export const getFollowings = (token) => {
    return axios.get(`${Config.MyDNV.azureFnPath}/getUserFollowings`, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });
};

export const postFollow = (args) => {
    return axios.post(`${Config.MyDNV.azureFnPath}/postFollow`, args.webpage, {
        headers: {
            Authorization: `Bearer ${args.token}`,
            "Content-Type": "application/json",
        },
    });
};

export const postUnfollow = (args) => {
    return axios.post(`${Config.MyDNV.azureFnPath}/postUnfollow`, args.webpage, {
        headers: {
            Authorization: `Bearer ${args.token}`,
            "Content-Type": "application/json",
        },
    });
};

export const getUserFollow = (args) => {
    return axios.post(`${Config.MyDNV.azureFnPath}/getUserFollow`, args.webpage, {
        headers: {
            Authorization: `Bearer ${args.token}`,
            "Content-Type": "application/json",
        },
    });
};
